<div class="modal-header">
    <h5 class="modal-title">{{id ? 'Bildirim Güncelle': 'Yeni Bildirim Oluştur'}}</h5>
    <button type="button" class="close" aria-label="Close" (click)="closeModal()">
        <span aria-hidden="true">&times;</span>
    </button>
</div>

<div class="modal-body">
    <form [formGroup]="notificationForm" (ngSubmit)="onSubmit()">

        <!-- Başlık -->
        <div class="form-group">
            <label for="title">Başlık <span class="text-danger">*</span></label>
            <ng-select [items]="titles" bindLabel="name" bindValue="name" placeholder="Başlık seçin"
                formControlName="title">
            </ng-select>

            <div *ngIf="notificationForm.get('title')?.invalid && notificationForm.get('title')?.touched"
                class="text-danger mt-1">
                Başlık zorunludur.
            </div>
        </div>


        <!-- Açıklama -->
        <div class="form-group">
            <label for="description">Açıklama</label>
            <textarea id="description" class="form-control" formControlName="description" rows="3"
                placeholder="Açıklama girin"></textarea>
        </div>

        <!-- Bitiş Tarihi -->
        <div class="form-group">
            <label for="expireAt">Bitiş Tarihi</label>
            <input type="datetime-local" id="expireAt" class="form-control" formControlName="expireAt">
            <small class="form-text text-muted">Bitiş tarihi boş bırakılırsa bildirim süresiz olur.</small>
        </div>

        <!-- Bildirim Tipi -->
        <div class="form-group">
            <label for="notificationType">Bildirim Tipi <span class="text-danger">*</span></label>
            <select id="notificationType" class="form-control" formControlName="notificationType">
                <option value="" disabled selected>Tip seçin</option>
                <option value="1">Bilgi</option>
                <option value="2">Başarılı</option>
                <option value="3">Uyarı</option>
                <option value="4">Hata</option>
            </select>
            <div *ngIf="notificationForm.get('notificationType')?.invalid && notificationForm.get('notificationType')?.touched"
                class="text-danger mt-1">
                Bildirim tipi zorunludur.
            </div>
        </div>

        <div class="form-group">
            <div class="form-check">
                <input type="checkbox" id="sendAllUsers" class="form-check-input" formControlName="sendAllUsers"
                (click)="!authService.isEndpointStatus('GET.Reading.GetUsers') ? $event.preventDefault() : null"
                    [ngStyle]="!authService.isEndpointStatus('GET.Reading.GetUsers') ? {'pointer-events':'none', 'opacity':'0.5'} : {}">
                <label class="form-check-label" for="sendAllUsers">
                    Tüm kullanıcılara gönder
                </label>
            </div>
        </div>

        <div class="form-group" *ngIf="!notificationForm.get('sendAllUsers')?.value">
            <label for="users">Kullanıcılar</label>
            <ng-select [items]="users" bindLabel="fullName" bindValue="id" placeholder="Kullanıcı seçin"
                formControlName="selectedUsers" [multiple]="true">
            </ng-select>
        </div>

        <!-- Güncellemede görülenleri sıfırla checkbox -->
        <div class="form-group" *ngIf="id">
            <div class="form-check">
                <input type="checkbox" id="resetReaders" class="form-check-input" formControlName="resetReaders">
                <label class="form-check-label" for="resetReaders">
                    Görülme durumlarını sıfırla
                </label>
            </div>
            <small class="form-text text-muted">
                Bu seçenek işaretlenirse güncellemeden sonra seçili kullanıcıların <b>okunma durumu sıfırlanır</b>.
            </small>
        </div>

        <div class="d-flex justify-content-end mt-4">
            <button type="button" class="btn btn-secondary mr-2" (click)="closeModal()">İptal</button>
            <button type="submit" class="btn btn-primary" [disabled]="notificationForm.invalid">Kaydet</button>
        </div>

    </form>
</div>